import React from 'react';

/* Icons */
import ChevronIcon from '~/../symbols/chevron.svg';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFlowPrevious({ steps, setStep }) {
    const navigatePreviousStep = () => {
        const activeStep = steps.find((step) => step.active);
        const previousStep = steps.find((step) => step.position === (activeStep.position - 1));

        if (previousStep) setStep(previousStep);
    }

    return (
        <Button
            className="p-0 font-weight-normal"
            theme="none"
            title={trans(`app.flow.previous`)}
            textClassName={'ml-1'}
            icon={ChevronIcon}
            iconSize={10}
            iconClassName={'icon--lg-14 icon--reversed'}
            withCircle={false}
            attributes={{ type: 'button' }}
            onClick={navigatePreviousStep}
        />
    )
}